import PropTypes from "prop-types";
import React, { useState } from "react";

import { Button } from "../Button";
import { ButtonTypes } from "../constants";
import { TextArea } from "../TextArea";

import { NPSSurveyWrapper } from "./NPSSurveyWrapper";

import "./styles.scss";

export const NPSScoreReason = ({ className, dismissHandler, submitHandler }) => {
  const [scoreReason, setScoreReason] = useState("");

  return (
    <NPSSurveyWrapper className={className} dismissHandler={dismissHandler}>
      <div className="NPSScoreReason--content_wrapper">
        <div className="NPSScoreReason--label">What&apos;s the main reason for your score?</div>
        <div className="NPSScoreReason--sub_label">
          Do not include patient identifying information.
        </div>
        <TextArea
          className="NPSScoreReason--input"
          onChange={(event) => {
            setScoreReason(event.target.value);
          }}
          placeholder="Please type here..."
        />
        <div className="NPSScoreReason--submit_button_wrapper">
          <Button
            buttonType={ButtonTypes.primaryV2}
            className="NPSScoreReason--submit_button"
            onClick={() => submitHandler(scoreReason)}
          >
            Submit
          </Button>
        </div>
      </div>
    </NPSSurveyWrapper>
  );
};

NPSScoreReason.propTypes = {
  className: PropTypes.string,
  dismissHandler: PropTypes.func.isRequired,
  submitHandler: PropTypes.func.isRequired,
};

NPSScoreReason.defaultProps = {
  className: undefined,
  dismissHandler: () => {},
  submitHandler: () => {},
};
